export default __webpack_public_path__ + "static/ProValue_2@1200-868270d860aad7d00e43da308594747f.webp";